Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getActiveElement;
function getActiveElement() {
  return typeof document !== 'undefined' && document.activeElement;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-dates/lib/utils/getActiveElement.js
// module id = 2846
// module chunks = 0